/* --- Election News --- */
function electionNews(){

	// Get the Sources
	var sources = document.querySelectorAll('[class^=election-source]');

	// Remove all actives sources
	function removeActive(){
		for (var i = sources.length - 1; i >= 0; i--) {
			sources[i].classList.remove('active');
		}
	}

	// MAke specified sources active
	function makeActive(selectedSource){
		var specificSources = document.querySelectorAll('.' + selectedSource.classList[0]);

		for (var i = specificSources.length - 1; i >= 0; i--) {
			specificSources[i].classList.add('active');
		}
	}

	// Add an mouse over event
	for (var i = sources.length - 1; i >= 0; i--) {
		sources[i].addEventListener('mouseover', function(){

			// Clean the sources to not be active
			removeActive();

			// Found out which source has been selected and get them all active
			makeActive(this);
		});
	}
}
